"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../util/constants");

require("./CampaignIcon.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CampaignIcon = function CampaignIcon(_ref) {
  var type = _ref.type,
      frame = _ref.frame,
      size = _ref.size,
      channel = _ref.channel;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-camp-icon ".concat(type === 0 ? 'inbound' : 'outbound', " gcl-").concat(size, " ").concat(channel != null ? 'with-channel' : ''),
    "data-camp-channel": _constants.CHANNEL_ICONS[channel]
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + _constants.CAMPAIGN_ICONS[frame - 1].icon
  }), channel != null && /*#__PURE__*/_react["default"].createElement("span", {
    className: "gcl-ci-channel"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + _constants.CHANNEL_ICONS[channel]
  })));
};

CampaignIcon.propTypes = {
  type: _propTypes["default"].oneOf([0, 1]),
  frame: _propTypes["default"].number,
  size: _propTypes["default"].oneOf(['sm', 'md', 'lg']),
  channel: _propTypes["default"].number
};
CampaignIcon.defaultProps = {
  type: 0,
  frame: 1,
  size: 'md'
};
var _default = CampaignIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/CampaignIcon/CampaignIcon.js
// module id = 690
// module chunks = 0